(function () {
    'use strict';

    /* ── Countdown helpers ──────────────────────────────────────── */
    var _cdInterval = null;

    function _flipUnit(curId, newVal) {
        var cur = document.getElementById(curId);
        var nxt = document.getElementById(curId + '-nxt');
        if (!cur) return;
        if (cur.textContent.trim() === newVal) return;
        if (window.gsap && nxt) {
            nxt.textContent = newVal;
            gsap.killTweensOf(cur);
            gsap.killTweensOf(nxt);
            var tl = gsap.timeline({
                onComplete: function () {
                    cur.textContent = newVal;
                    gsap.set(cur, { y: '0%', scale: 1, opacity: 1, rotationX: 0, filter: 'blur(0px)' });
                    gsap.set(nxt, { y: '100%', scale: 1, opacity: 1, rotationX: 0, filter: 'blur(0px)' });
                }
            });
            tl.fromTo(cur, { y: '0%', scale: 1, opacity: 1, rotationX: 0, filter: 'blur(0px)' }, { y: '-80%', scale: 0.85, opacity: 0, rotationX: 45, filter: 'blur(4px)', duration: 0.35, ease: 'power2.in' }, 0)
              .fromTo(nxt, { y: '80%', scale: 0.85, opacity: 0, rotationX: -45, filter: 'blur(4px)' }, { y: '0%', scale: 1, opacity: 1, rotationX: 0, filter: 'blur(0px)', duration: 0.45, ease: 'back.out(1.4)' }, 0.1);
        } else {
            cur.textContent = newVal;
        }
    }

    function _startCountdown(targetMs) {
        if (_cdInterval) { clearInterval(_cdInterval); _cdInterval = null; }
        function tick() {
            var diff = targetMs - Date.now();
            if (diff < 0) diff = 0;
            var d = String(Math.floor(diff / 86400000)).padStart(2, '0');
            var h = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
            var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
            var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
            _flipUnit('cdDays',  d);
            _flipUnit('cdHours', h);
            _flipUnit('cdMins',  m);
            _flipUnit('cdSecs',  s);
            if (diff <= 0) { clearInterval(_cdInterval); _cdInterval = null; }
        }
        tick();
        _cdInterval = setInterval(tick, 1000);
    }

    /* ── Populate invite preview from formDataStorage ─────────────────── */
    function updateInvitePreview() {
        if (!window.formDataStorage) return;
        const d = window.formDataStorage.getStoredData() || {};

        // Title
        const titleEl = document.getElementById('invitePreviewTitle');
        if (titleEl) {
            const t = d.event_title || '';
            if (t) {
                titleEl.textContent = t;
                titleEl.classList.remove('placeholder-text');
            } else {
                titleEl.textContent = 'Alex & Taylor\'s Wedding';
                titleEl.classList.add('placeholder-text');
            }
        }

        // Hashtag
        const hashtagEl  = document.getElementById('invitePreviewHashtag');
        const hashtagTxt = document.getElementById('invitePreviewHashtagText');
        if (hashtagEl && hashtagTxt) {
            const h = d.hashtag || '';
            if (h) {
                hashtagTxt.textContent = h;
                hashtagEl.classList.remove('placeholder-text');
            } else {
                hashtagTxt.textContent = 'foreverlove2026 🥂';
                hashtagEl.classList.add('placeholder-text');
            }
        }

        // Description – render as HTML, clamp to 3 rows, show read-more
        const descEl = document.getElementById('invitePreviewDesc');
        const readMoreBtn = document.getElementById('inviteDescReadMore');
        if (descEl) {
            const raw = d.event_details || '';
            // Also update the full-view sidebar tab
            const descFull = document.getElementById('eventDetailsPreviewBody');
            if (raw.trim()) {
                descEl.innerHTML = raw;
                descEl.classList.remove('placeholder-text');
                if (descFull) descFull.innerHTML = raw;
            } else {
                descEl.textContent = 'Join us as we tie the knot and celebrate our love story! 🌟 We can\'t wait to share this magical day filled with joy, laughter, and wonderful memories with all our favorite people. 🤵👰💒🥂';
                descEl.classList.add('placeholder-text');
                if (descFull) descFull.innerHTML = '';
            }
            requestAnimationFrame(function () {
                if (readMoreBtn) {
                    readMoreBtn.style.display = descEl.scrollHeight > descEl.clientHeight + 4 ? 'inline-flex' : 'none';
                }
            });
        }

        // Feature chips
        const featuresEl = document.getElementById('invitePreviewFeatures');
        if (featuresEl) {
            const chips = [
                { label: 'Invite',   icon: 'bi-envelope-paper',   cls: 'feat-invite',   always: true,                              ppm: 'details'         },
                ...(window.themeInfo && window.themeInfo.rsvp_feature          ? [{ label: 'RSVP',     icon: 'bi-person-check',     cls: 'feat-rsvp',     key: 'rsvp_enabled',        truthy: true, ppm: 'rsvp'           }] : []),
                ...(window.themeInfo && window.themeInfo.location_feature      ? [{ label: 'Venue',    icon: 'bi-geo-alt-fill',     cls: 'feat-venue',    key: 'venue_name',          truthy: true, ppm: 'venue-details'  }] : []),
                { label: 'Schedule', icon: 'bi-calendar-event',   cls: 'feat-schedule', key: 'schedule_items',      array:  true, ppm: 'event-schedule'  },
                { label: 'Gallery',  icon: 'bi-images',           cls: 'feat-gallery',  key: 'gallery_url',         truthy: true, ppm: 'gallery-link'    },
                ...(window.themeInfo && window.themeInfo.gift_registry_feature ? [{ label: 'Gifts',    icon: 'bi-gift-fill',        cls: 'feat-gifts',    key: 'gift_registry_items', array:  true, ppm: 'gift-registry'  }] : []),
                { label: 'Password', icon: 'bi-shield-lock-fill', cls: 'feat-password', password: true, ppm: 'invite-password' },
                ...(window.themeInfo && window.themeInfo.background_music_feature ? [{ label: 'Music', icon: 'bi-music-note-beamed', cls: 'feat-music', key: '_music', custom: true, ppm: 'background-music' }] : []),
                { label: 'Thank You',icon: 'bi-heart-fill',       cls: 'feat-thanks',   key: 'thank_you_message',   truthy: true, ppm: 'thank-you-page'  },
            ];
            const html = chips.map(c => {
                let active = c.always;
                if (!active && c.custom === true) {
                    // Music: stored as d.backgroundMusic (new upload) or d.files.background_music (server)
                    active = !!(d.backgroundMusic && (d.backgroundMusic.fileName || d.backgroundMusic._hasPendingFile))
                          || !!(d.files && d.files.background_music);
                } else if (!active && c.password === true) {
                    // Password: enabled toggle must be true AND a password value must be set
                    const enabledStr = String(d.invite_password_enabled).toLowerCase();
                    const enabled = enabledStr === 'true' || enabledStr === 'on' || enabledStr === '1';
                    const hasValue = d.invite_password_value && String(d.invite_password_value).trim() !== '';
                    active = enabled && hasValue;
                } else if (!active && c.key) {
                    const val = d[c.key];
                    if (c.array) active = Array.isArray(val) && val.length > 0;
                    else active = val === true || val === 'true' || (typeof val === 'string' && val.trim() !== '');
                }
                const cls = active ? `invite-feature-card ${c.cls}` : `invite-feature-card ${c.cls} card-inactive`;
                const icon = (c.password === true) ? (active ? 'bi-shield-lock-fill' : 'bi-unlock') : c.icon;
                const action = c.model ? `window.showModel('${c.model}')` : `openPPMWithAuth('${c.ppm}')`;
                return `<div class="${cls}" onclick="${action}" title="Edit ${c.label}">
                    <div class="feat-icon"><i class="bi ${icon}"></i></div>
                    <span>${c.label}</span>
                </div>`;
            }).join('');

            // "More" card – always last, always active style
            const moreCard = `<div class="invite-feature-card feat-more" onclick="openPPM('features')" title="All features">
                    <div class="feat-icon"><i class="bi bi-grid-3x3-gap-fill"></i></div>
                    <span>More</span>
                </div>`;

            featuresEl.innerHTML = html + moreCard;
        }

        // Countdown
        var cdBlock = document.getElementById('invitePreviewCountdown');
        if (cdBlock) {
            var cdOn = d.countdown_enabled === true || d.countdown_enabled === 'true' || d.countdown_enabled === 'on';
            if (cdOn && d.event_date) {
                var tStr = (d.event_time || '00:00');
                var tDate = new Date(d.event_date + 'T' + tStr + (tStr.length === 5 ? ':00' : ''));
                if (!isNaN(tDate.getTime())) {
                    if (cdBlock.style.display === 'none') {
                        cdBlock.style.display = '';
                        if (window.gsap) gsap.fromTo(cdBlock, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' });
                    }
                    _startCountdown(tDate.getTime());
                } else {
                    cdBlock.style.display = 'none';
                    if (_cdInterval) { clearInterval(_cdInterval); _cdInterval = null; }
                }
            } else {
                if (cdBlock.style.display !== 'none') {
                    if (window.gsap) {
                        gsap.to(cdBlock, { opacity: 0, y: -6, duration: 0.25, ease: 'power2.in', onComplete: function () { cdBlock.style.display = 'none'; gsap.set(cdBlock, { opacity: 1, y: 0 }); } });
                    } else {
                        cdBlock.style.display = 'none';
                    }
                    if (_cdInterval) { clearInterval(_cdInterval); _cdInterval = null; }
                }
            }
        }
    }

    /* Run once when formDataStorage is ready, then on every save */
    function tryInit() {
        if (window.formDataStorage) {
            updateInvitePreview();
            window.updateInvitePreview = updateInvitePreview;
            // Patch saveFormData to re-render after any save
            const origSave = window.formDataStorage.saveFormData.bind(window.formDataStorage);
            window.formDataStorage.saveFormData = function (data) {
                origSave(data);
                updateInvitePreview();
            };
        } else {
            setTimeout(tryInit, 200);
        }
    }

    /* ── Description overlay removed – now uses sidebar tab ────────── */

    /* ── Live branding logo update via MutationObserver ──────────────── */
    function watchBrandingLogo() {
        var logoPreviewContainer = document.getElementById('brandingLogoPreview');
        if (!logoPreviewContainer) { setTimeout(watchBrandingLogo, 600); return; }
        var sidebarLogoImg = document.getElementById('invitePreviewBrandLogo');
        if (!sidebarLogoImg) return;
        var obs = new MutationObserver(function () {
            var uploadedImg = logoPreviewContainer.querySelector('img.preview-image');
            if (uploadedImg && uploadedImg.src && !uploadedImg.src.endsWith('undefined')) {
                sidebarLogoImg.src = uploadedImg.src;
            }
        });
        obs.observe(logoPreviewContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    setTimeout(watchBrandingLogo, 800);

    // Also refresh whenever the theme-info tab becomes visible
    const themeInfoModel = document.querySelector('[data-model="theme-information-tab"]');
    if (themeInfoModel) {
        const obs = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.type === 'attributes' && m.attributeName === 'data-state') {
                    if (themeInfoModel.getAttribute('data-state') === 'show') {
                        updateInvitePreview();
                    }
                }
            });
        });
        obs.observe(themeInfoModel, { attributes: true });
    }

    /* ── Live preview: update on every keystroke inside PPM ─────────── */
    document.addEventListener('input', function (e) {
        if (!window.formDataStorage) return;
        var t = e.target;
        var id = t.id;
        if (id === 'eventTitle' || id === 'hashtag') {
            var d = window.formDataStorage.getStoredData() || {};
            if (id === 'eventTitle') d.event_title = t.value;
            if (id === 'hashtag')    d.hashtag      = t.value;
            var origGet = window.formDataStorage.getStoredData.bind(window.formDataStorage);
            window.formDataStorage.getStoredData = function () { return d; };
            updateInvitePreview();
            window.formDataStorage.getStoredData = origGet;
        }
        // contenteditable event-details editor
        if (t.classList && t.classList.contains('content-edit-body')) {
            var d2 = window.formDataStorage.getStoredData() || {};
            d2.event_details = t.innerHTML;
            var origGet2 = window.formDataStorage.getStoredData.bind(window.formDataStorage);
            window.formDataStorage.getStoredData = function () { return d2; };
            updateInvitePreview();
            window.formDataStorage.getStoredData = origGet2;
        }
    }, true);

    // Live preview: countdown toggle + date/time changes (fire before form is saved)
    document.addEventListener('change', function (e) {
        if (!window.formDataStorage) return;
        var t = e.target;
        var key = t.getAttribute('data-theme-key');
        if (!key) return;
        if (key === 'countdown_enabled' || key === 'event_date' || key === 'event_time') {
            var d = window.formDataStorage.getStoredData() || {};
            if (t.type === 'checkbox') {
                d[key] = t.checked;
            } else {
                d[key] = t.value;
            }
            window.formDataStorage._liveOverride = d;
            var origGet = window.formDataStorage.getStoredData.bind(window.formDataStorage);
            window.formDataStorage.getStoredData = function () { return window.formDataStorage._liveOverride || origGet(); };
            updateInvitePreview();
            window.formDataStorage.getStoredData = origGet;
            window.formDataStorage._liveOverride = null;
        }
    }, true);

    // Also refresh preview whenever formDataStorage saves (covers all other fields)
    window.addEventListener('formDataSaved', function () {
        updateInvitePreview();
    });

    /* ── Keep event-details preview tab in sync when opened ────────── */
    var detailsPreviewModel = document.querySelector('[data-model="event-details-preview-tab"]');
    if (detailsPreviewModel) {
        var detailsObs = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.type === 'attributes' && m.attributeName === 'data-state') {
                    if (detailsPreviewModel.getAttribute('data-state') === 'show') {
                        var body = document.getElementById('eventDetailsPreviewBody');
                        if (!body) return;
                        var d = (window.formDataStorage && window.formDataStorage.getStoredData()) || {};
                        var raw = d.event_details || '';
                        if (raw.trim()) {
                            body.innerHTML = raw;
                            body.classList.remove('event-details-preview-placeholder-wrap');
                        } else {
                            body.innerHTML = '<p class="event-details-preview-placeholder">No description added yet. Click "Edit Description" to add one.</p>';
                        }
                    }
                }
            });
        });
        detailsObs.observe(detailsPreviewModel, { attributes: true });
    }

    // On #tdiCurrencySelector change, update the preview and set a cookie so the value persists on reload
    var tdiCurrencySelector = document.getElementById('tdiCurrencySelector');
    if (tdiCurrencySelector) {
        tdiCurrencySelector.addEventListener('change', function () {
            var selectedCurrency = this.value;
            // Set cookie for 30 days
            var d = new Date();
            d.setTime(d.getTime() + (30*24*60*60*1000));
            document.cookie = "currency=" + selectedCurrency + ";expires=" + d.toUTCString() + ";path=/";

            // Make data-selected-currency = true for the selected currency and false for others
            var currencyElements = document.querySelectorAll('[data-card-currency]');
            currencyElements.forEach(function(el) {
                if (el.getAttribute('data-card-currency') === selectedCurrency) {
                    el.setAttribute('data-selected-currency', 'true');
                } else {
                    el.setAttribute('data-selected-currency', 'false');
                }
            });
        });
    }

    /* ── Pay & Publish button ─────────────────────────────────────────── */
    function openPaymentPopup() {
        // Hard gate: never open unless all required fields are filled
        if (!validateRequiredFields()) return;
        var overlay = document.getElementById('paymentPopupOverlay');
        if (overlay) {
            overlay.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }
    }
    function closePaymentPopup() {
        var overlay = document.getElementById('paymentPopupOverlay');
        if (overlay) {
            overlay.style.display = 'none';
            document.body.style.overflow = '';
        }
    }
    window.openPaymentPopup   = openPaymentPopup;
    window.closePaymentPopup  = closePaymentPopup;
    window.validatePaymentFields = validateRequiredFields;

    /* ── Required-field validation ───────────────────────────────────────── */
    function validateRequiredFields() {
        // Query the full document — scoping to [data-ppm-tab="details"] misses
        // inputs inside collapsible-card wrappers that sit outside that subtree.
        var inputs   = document.querySelectorAll('[data-field-required="true"]');
        var failures = [];

        inputs.forEach(function (input) {
            var value = (input.value || '').trim();
            if (!value) failures.push(input);
        });

        if (failures.length === 0) return true;

        // Open the details tab first so the input is visible, then highlight
        if (typeof window.openPPM === 'function') window.openPPM('details');

        setTimeout(function () {
            failures.forEach(function (inp) { _markFieldError(inp); });
            failures[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            failures[0].focus();
        }, 300);

        return false;
    }

    function _markFieldError(input) {
        input.classList.remove('ppm-input-shake');
        input.classList.add('ppm-input-error');
        void input.offsetWidth; // reflow to restart animation
        input.classList.add('ppm-input-shake');

        // If inside a collapsed card → expand it and mark the card header in red
        var card = input.closest('.collapsible-card');
        if (card) {
            if (card.dataset.toggleState !== 'open') {
                card.dataset.toggleState = 'open';
            }
            card.classList.add('ppm-card-error');
        }

        var group = input.closest('.form-group');
        if (group && !group.querySelector('.ppm-error-msg')) {
            var msg = document.createElement('p');
            msg.className = 'ppm-error-msg';
            msg.innerHTML = '<i class="bi bi-exclamation-circle-fill"></i> This field is required';
            group.appendChild(msg);
        }

        input.addEventListener('animationend', function () {
            input.classList.remove('ppm-input-shake');
        }, { once: true });

        function clearOnChange() { _clearFieldError(input); }
        input.addEventListener('input',  clearOnChange, { once: true });
        input.addEventListener('change', clearOnChange, { once: true });
    }

    function _clearFieldError(input) {
        input.classList.remove('ppm-input-error', 'ppm-input-shake');
        var group = input.closest('.form-group');
        if (group) {
            var msg = group.querySelector('.ppm-error-msg');
            if (msg) msg.remove();
        }
        // Remove card-level error highlight when the field is filled
        var card = input.closest('.collapsible-card');
        if (card) card.classList.remove('ppm-card-error');
    }

    function _initPayBtn() {
        tryInit();
        var payBtn = document.getElementById('openPaymentPopupBtn');
        if (!payBtn || payBtn._payListenerAttached) return;
        payBtn._payListenerAttached = true;

        payBtn.addEventListener('click', function () {
            window.requireAuth(function () {
                if (!validateRequiredFields()) return;

                // Both create and update: skip popup, submit directly.
                // Creation is free — payment happens at the share/unlock step.
                payBtn.disabled = true;
                var originalHTML = payBtn.innerHTML;
                payBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span>';
                if (typeof window.processToPayment === 'function') {
                    window.processToPayment().catch(function () {
                        payBtn.disabled = false;
                        payBtn.innerHTML = originalHTML;
                    });
                }
            });
        });
    }

    // Run immediately if DOM is already loaded (common in webpack bundles).
    // A plain DOMContentLoaded listener never fires when the bundle executes
    // after the DOM is interactive — the event has already been dispatched.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _initPayBtn);
    } else {
        _initPayBtn();
    }

    /* ── Mobile: show theme-info-strip above footer when preview scrolls away ── */
    (function _initStripVisibility() {
        var strip = document.querySelector('.theme-info-strip');
        var preview = document.getElementById('themePreviewContainer');
        if (!strip || !preview || !window.IntersectionObserver) return;

        var observer = new IntersectionObserver(function (entries) {
            // Only apply on mobile widths
            if (window.innerWidth > 768) return;
            var visible = entries[0].isIntersecting;
            strip.classList.toggle('theme-info-strip--floating', !visible);
        }, {
            threshold: 0,
            // Fire as soon as the bottom edge of the preview leaves the top of the viewport
            rootMargin: '0px 0px 0px 0px'
        });

        observer.observe(preview);

        // Re-evaluate on resize (desktop ↔ mobile switch)
        window.addEventListener('resize', function () {
            if (window.innerWidth > 768) {
                strip.classList.remove('theme-info-strip--floating');
            }
        }, { passive: true });
    }());
}());
